import React from "react";
import { makeStyles } from "tss-react/mui";
import { Box, Drawer } from "@mui/material";
import CustomDrawerHeader from "./CustomDrawerHeader";

const useStyles = makeStyles()((theme) => {
  return {
    drawerPaper: {
      margin: "10px",
      width: 700,
      height: "calc(100% - 20px)",
      borderRadius: "30px",
      zIndex: theme.zIndex.drawer + 2,
      position: "absolute",
    },
  };
});

export default function CustomDrawer({
  isDrawerOpen,
  handleClose,
  anchor,
  title,
  subtitle,
  otherText,
  fontSize,
  children,
  isOnlyIconClose = false
}) {
  const { classes } = useStyles();
  return (
    <Drawer
      open={isDrawerOpen}
      onClose={!isOnlyIconClose && handleClose}
      anchor={anchor || "right"}
      variant="temporary"
      classes={{ paper: classes?.drawerPaper }}
      transitionDuration={{ enter: 500, exit: 500 }}
    >
      {title ? (
        <Box m={0}>
          <CustomDrawerHeader
            handleClose={handleClose}
            title={title}
            subtitle={subtitle}
            otherText={otherText}
            fontSize={fontSize}
          />
        </Box>
      ) : null}
      {children}
    </Drawer>
  );
}
